import * as React from "react";
import { FC, useMemo } from "react";

interface Props {
  value: string;
  maxLength?: number;
}

const TableSlicedString: FC<Props> = props => {
  const { value, maxLength = 50 } = props;

  const useTrimmedValue = useMemo(() => typeof value === "string" && value.length > maxLength, [value]);

  const trimmedValue = useMemo(() => useTrimmedValue ? value.trim().slice(0, maxLength) + "…" : value,
    [value, useTrimmedValue]);

  return (
    <div className="sliced__string">
      {trimmedValue}
      {useTrimmedValue &&
        <div className="sliced__string--popup">{value}</div>
      }
    </div>
  )
}

export default TableSlicedString;
